import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/app.component.scss.ngstyle.ts